import { PostVisibilityEnum } from 'redux-store/api/activity-feed';
import { ICONS_MAP } from './constants';
import { TConvertedAudience } from '../types';

const formatAndCapitalize = (str: string) =>
  str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

const isSelectedEveryone = (postAudience: TConvertedAudience, profilesCount: number) => {
  const { byRole = [], customGroups = [] } = postAudience || {};

  const uniqueProfileIds = [...byRole, ...customGroups]
    .flatMap((item) => item.profiles)
    .map((profile) => profile.profileId)
    .filter((profileId, index, self) => self.indexOf(profileId) === index);

  return uniqueProfileIds.length === profilesCount;
};

const getAudienceDetails = (
  postVisibility: PostVisibilityEnum,
  postAudience: TConvertedAudience,
  profilesCount: number
): { buttonText: string; icon: JSX.Element } => {
  if (
    postVisibility === PostVisibilityEnum.EVERYONE ||
    isSelectedEveryone(postAudience, profilesCount) ||
    !postAudience
  ) {
    return { icon: ICONS_MAP.EVERYONE, buttonText: PostVisibilityEnum.EVERYONE };
  }

  if (postVisibility === PostVisibilityEnum.JUST_ME) {
    return { icon: ICONS_MAP.JUST_ME, buttonText: PostVisibilityEnum.JUST_ME };
  }

  if (postVisibility === PostVisibilityEnum.SPECIFIC_MEMBERS) {
    const { byRole = [], customGroups = [], customUsers = [] } = postAudience || {};

    const specificAudienceCount = customGroups.length + byRole.length;
    const name = customGroups?.[0]?.groupName || byRole?.[0]?.groupName?.toUpperCase();

    if (specificAudienceCount === 1) {
      return { icon: ICONS_MAP[name] || ICONS_MAP.CUSTOM, buttonText: name };
    }

    if (customUsers.length || specificAudienceCount > 1) {
      return { icon: ICONS_MAP.CUSTOM, buttonText: 'CUSTOM' };
    }

    return { icon: ICONS_MAP.CUSTOM, buttonText: 'CUSTOM' };
  }

  return { icon: ICONS_MAP.CUSTOM, buttonText: 'NOT_DEFINED' };
};

export { formatAndCapitalize, getAudienceDetails };
